import { FC, useEffect } from 'react';
import { Box, TextField } from '@mui/material';
import { useForm } from '@tanstack/react-form';
import { z } from 'zod';
import { motion, transform, useAnimate } from 'motion/react';
import { useTranslation } from 'react-i18next';

import { useTextEditorStore } from './TextEditorStore';

const textSchema = z.object({
  text: z.string().min(2), //.max(12, { message: 'Should not be longer than 12 chars.' }),
});

// const FieldInfo = ({ field }: { field: AnyFieldApi }) => {
//   return (
//     <>
//       {field.state.meta.isTouched && field.state.meta.errors.length ? (
//         <FormHelperText>
//           {field.state.meta.errors.map((err) => err.message).join(',')}
//         </FormHelperText>
//       ) : null}
//       {field.state.meta.isValidating ? 'Validating...' : null}
//     </>
//   );
// };

export const TextForm: FC = () => {
  const { setText, maxStringLength, setIsValidString } = useTextEditorStore();
  const { t } = useTranslation();
  const form = useForm({
    defaultValues: {
      text: '',
    },

    onSubmit: async () => {},

    validators: {
      onChange: textSchema,
    },
    listeners: {
      // onMount: ({ formApi }) => {},

      onChange: ({ formApi, fieldApi }) => {
        // autosave logic
        if (formApi.state.isValid) {
          setIsValidString(true);
        } else {
          setIsValidString(false);
        }

        // fieldApi represents the field that triggered the event.
        console.log(fieldApi.name, fieldApi.state.value);
      },
      onChangeDebounceMs: 500,
    },
  });

  const charactersRemaining =
    maxStringLength - form.getFieldValue('text')?.length || 0;
  const [counterRef, animate] = useAnimate();

  const mapRemainingToColor = transform([2, 6], ['#FF7B00FF', '#ccc']);

  useEffect(() => {
    if (charactersRemaining > 6) return;

    const mapRemainingToSpringVelocity = transform([0, 5], [50, 0]);

    animate(
      counterRef.current,
      { scale: 1 },
      {
        type: 'spring',
        velocity: mapRemainingToSpringVelocity(charactersRemaining),
        stiffness: 700,
        damping: 80,
      }
    );
  }, [animate, charactersRemaining]);

  return (
    <Box
      component="form"
      sx={{
        width: '100%',
      }}
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        form.handleSubmit();
      }}
    >
      <form.Field
        name="text"
        listeners={{
          onChange: ({ value }) => {
            console.log(`Country changed to: ${value}, resetting province`);
            setText(value);
          },
        }}
        children={(field) => {
          // console.log('field', field.state);
          return (
            <TextField
              id="text"
              label={t('yourName')}
              required
              type="text"
              fullWidth
              value={field.state.value}
              onChange={(e) => field.handleChange(e.target.value)}
              onBlur={field.handleBlur}
              placeholder={t('yourName')}
              slotProps={{
                htmlInput: {
                  maxLength: maxStringLength,
                },
                input: {
                  endAdornment: (
                    <Box
                      sx={{
                        backgroundColor: 'primary.main',
                        paddingTop: '2px',
                        paddingBottom: '2px',
                        paddingLeft: '10px',
                        paddingRight: '10px',
                        borderRadius: '40px',
                        color: 'white',
                      }}
                    >
                      <motion.span
                        ref={counterRef}
                        style={{
                          color: mapRemainingToColor(charactersRemaining),
                          willChange: 'transform',
                        }}
                      >
                        {charactersRemaining}
                      </motion.span>
                    </Box>
                  ),
                },
              }}
            />
          );
        }}
      />

      {/* <form.Subscribe
          selector={(state) => [state.isValid && !state.isPristine]}
          children={([canSubmit, isSubmitting]) => {
            // console.log('canSubmit', canSubmit);
            
            return (
              <Button variant="contained" type="submit" disabled={!canSubmit}>
                {isSubmitting ? '...' : 'Submit'}
              </Button>
            );
          }}
        /> */}
    </Box>
  );
};
